    <ui-table
      [data]="fairBalanceIssues"
      [templates]="[
        {
            title: '',
            template: consistencyCheckType,
            colClass: 'claim-consistencies-table-column claim-consistencies-table-nobreaks-column claim-consistencies-table-checkType-column'
        },
        {
          title: 'translate.fairBalanceIssues.category',
          template: category,
          colClass: 'claim-consistencies-table-column'
        },
        {
          title: 'translate.fairBalanceIssues.explanation',
          template: explanation,
          colClass: 'claim-consistencies-table-column'
        },
        {
            title: 'translate.fairBalanceIssues.recommendations',
            template: recommendations,
            colClass: 'claim-consistencies-table-column'
        },
        {
          title: 'translate.fairBalanceIssues.action',
          template: actions,
          colClass: 'claim-consistencies-table-column claim-consistencies-table-actions-column'
        }
      ]"
    ></ui-table>
    
    <ng-template #consistencyCheckType let-row="row">
      <span>
            <i  style="width: 30px; margin-right: 10px; margin-left: 10px;" [class]='row.icon'
            [tooltip]="row.tooltip | translate">
            </i>
      </span>
    </ng-template>
    <ng-template #explanation let-row="row">
            <span *ngIf="row.explanation">{{ row.explanation }}</span>
    </ng-template>

        <ng-template #category let-row="row">
          <span *ngIf="row.category"
            class="fair-balance-issues-category-pill"
            [ngClass]="getCategoryClass(row.category)">
            {{ "translate.fairBalanceIssues." + row.category | translate }}
          </span>
    </ng-template>

    
    <ng-template #recommendations let-row="row">
            
            <span *ngIf="row.recommendations">{{ row.recommendations }}</span>
    </ng-template>

    <ng-template #actions let-row="row">
                <a (click)="viewFairBalanceIssue(row)" [disabled]="!row.visibleViewActions">
                  <i [ngClass]="row.visibleViewActions ? 'fas fa-eye icon-view' : 'fas fa-eye-slash crossed-eye-background'" tooltip="{{ 'translate.general.view' | translate  }}"></i>
                </a>
                <span class="action-divider">|</span>
                <a  [class.disabled]="disableActions" (click)="removeFairBalanceIssue(row)">
                  <i [class.disabled]="disableActions" class="fa-solid fa-xmark" tooltip="{{ 'translate.general.remove' | translate  }}"></i>
                </a>
            
    </ng-template>

        <view-page-and-annotate-element *ngIf="viewerObject && viewerObject.type === 'FAIR_BALANCE_ISSUE_REF'"
            [embeddedObjectAnnotation]="viewerObject.data"
            (closePdfViewerEmitter)="viewerObject = null">
        </view-page-and-annotate-element>